import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import fontFamilies from '~/styles/themes/fontFamilies';

const Text = styled.span`
  font-family: ${({ fontFamily }) => fontFamilies[fontFamily]};
`;

const BuilderRichText = ({ attributes, fontFamily, text }) => {
  return (
    <Text
      fontFamily={fontFamily}
      {...attributes}
      dangerouslySetInnerHTML={{
        __html: text,
      }}
    />
  );
};

BuilderRichText.propTypes = {
  attributes: PropTypes.object,
  builderBlock: PropTypes.object,
  builderState: PropTypes.object,
  fontFamily: PropTypes.string,
  fontVariant: PropTypes.string,
  text: PropTypes.string,
};

export default BuilderRichText;
